(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 172);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var transformNodeText = function transformNodeText(text) {
  return text.toLowerCase().trim().replace(/[\s\-\.]/g, '_');
};

var getCompanyFromNode = function getCompanyFromNode(node) {
  var companyNode = node.querySelector(".project-overlay__company");

  return transformNodeText(companyNode.innerHTML);
};

var convertLanguage = {
  'ca_en': 'en_CA',
  'ko': 'ko_KR',
  'fi': 'fi_FI',
  'zh': 'zh_CH',
  'au': 'en_AU',
  'gb': 'en_GB',
  'la_es': 'es_LATAM',
  'ca_fr': 'fr_CA'
};

var getVideoPayload = function getVideoPayload(node, currentPage) {
  var lang = convertLanguage[currentPage];
  var current_page = getCurrentPage(currentPage);
  var feature = node.getAttribute('data-feature');

  return lang ? { region: lang, feature: feature } : { current_page: current_page, feature: feature };
};

var getDownloadPayload = function getDownloadPayload(node, currentPage) {
  var lang = convertLanguage[currentPage];
  var current_page = getCurrentPage(currentPage);
  var platform = node.getAttribute('data-platform');

  return lang ? { region: lang, platform: platform } : { current_page: current_page, platform: platform };
};

var getCurrentPage = function getCurrentPage(pagename) {
  var regional = isRegionalPage(pagename);

  if (pagename.match(/\./)) return pagename.split('.')[1];

  return regional || pagename;
};

var isRegionalPage = function isRegionalPage(currentPage) {
  return convertLanguage[currentPage];
};

var getHref = function getHref(node) {
  return transformNodeText(node.getAttribute('href'));
};

var getRegionalHeaderLinkName = function getRegionalHeaderLinkName(node) {
  var linkName = node.getAttribute('data-link-name');
  if (linkName) return linkName;

  var splitHref = node.href.split('/');
  var clickedLink = splitHref[splitHref.length - 1].replace('-', '_');

  return clickedLink === '' ? "en_US" : convertLanguage[clickedLink];
};

var featureExploreEventName = function featureExploreEventName(pagename) {
  var regional = isRegionalPage(pagename);

  return regional ? 'splash.regional.feature_explore.click' : 'splash.feature_explore.click';
};

var downloadEventName = function downloadEventName(pagename) {
  var regional = isRegionalPage(pagename);

  return regional ? 'splash.regional.download.click' : 'splash.product.download.click';
};

module.exports = {
  transformNodeText: transformNodeText,
  getCompanyFromNode: getCompanyFromNode,
  getHref: getHref,
  getCurrentPage: getCurrentPage,
  getRegionalHeaderLinkName: getRegionalHeaderLinkName,
  convertLanguage: convertLanguage,
  getVideoPayload: getVideoPayload,
  getDownloadPayload: getDownloadPayload,
  featureExploreEventName: featureExploreEventName,
  downloadEventName: downloadEventName
};

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCookie = getCookie;
exports.jsonpSuccess = jsonpSuccess;
exports.detectUserCountry = detectUserCountry;
exports.changePhoneNumbers = changePhoneNumbers;
exports.openNewWindow = openNewWindow;
exports.getParameterByName = getParameterByName;
exports.insertUtmInForms = insertUtmInForms;
exports.insertUtmInFormsFields = insertUtmInFormsFields;
exports.convertMonthFormat = convertMonthFormat;
exports.convertTimeFormat = convertTimeFormat;
exports.convertTimezone = convertTimezone;
exports.embbedSvgImages = embbedSvgImages;
exports._ = _;
exports.showPopUp = showPopUp;
exports.getClosest = getClosest;
/*
 * Syntatic sugar
 */
var qs = exports.qs = function qs(x) {
  return document.querySelector(x);
};

var qsa = exports.qsa = function qsa(x) {
  return document.querySelectorAll(x);
};

/*
 * Custom get a cookie value
 */
function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

/*
 * callback for detectUserCountry ajax call
 */
function jsonpSuccess(response) {

  document.cookie = 'userCountry=' + response.country;
  userCountry = response.country;

  changePhoneNumbers(userCountry);
}

/*
 * Detect user country and change phones
 */

function detectUserCountry() {

  //Check user location
  var userCountry = getCookie('userCountry');
  if (userCountry === '') {

    var scr = document.createElement('script');
    scr.src = '//ipinfo.io?callback=jsonpSuccess';
    document.body.appendChild(scr);
  } else {
    changePhoneNumbers(userCountry);
  }
}

function changePhoneNumbers(userCountry) {

  switch (userCountry) {

    case 'AU':
      qs('.conditional-phone-number-small').innerHTML('1800 316 406');
      qs('.conditional-phone-number-big').innerHTML('1800 316 406');
      qs('.conditional-phone-number-link').setAttribute('href', 'tel:+611800316406');
      break;

    case 'GB':
      qs('.conditional-phone-number-small').innerHTML('020 3695 0292');
      qs('.conditional-phone-number-big').innerHTML('+44 (0)20 3695 0292');
      qs('.conditional-phone-number-link').setAttribute('href', 'tel:+4402036950292');
      break;

    case 'US':
      qs('.conditional-phone-number-small').innerHTML('800-646-0796');
      qs('.conditional-phone-number-big').innerHTML('+1 (800) 646-0796');
      qs('.conditional-phone-number-link').setAttribute('href', 'tel:+18006460796');
      qs('.int-locations').before(qs('.us-locations'));
      break;

  }
}

function openNewWindow() {
  qs("a.btn").setAttribute("target", "_blank");
  qs("a.button").setAttribute("target", "_blank");
}

/*
 * Get query values on URL
 */
function getParameterByName(name, url) {

  if (!url) {
    url = window.location.href;
  }

  name = name.replace(/[\[\]]/g, "\\$&");

  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);

  if (!results) {
    return null;
  }

  if (!results[2]) {
    return '';
  }

  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/*
 * Automatically insert UTM variables on forms
 */
function insertUtmInForms() {

  var utmList = ['utm_source', 'utm_medium', 'utm_campaign'],
      check = '';

  for (var i = 0; i < utmList.length; i++) {

    check = getParameterByName(utmList[i]);
    if (check !== null && check !== '') {
      insertUtmInFormsFields(utmList[i], check);
    }
  }
}

function insertUtmInFormsFields(name, value) {
  if (qs('form')) {
    qs('form').prepend('<input type="hidden" name="' + name + '" value="' + value + '" />');
  }
}

insertUtmInForms();

/*
 * Convert Month Format
 */
function convertMonthFormat(date, format) {

  months = {
    'JAN': '01',
    'FEB': '02',
    'MAR': '03',
    'APR': '04',
    'MAY': '05',
    'JUN': '06',
    'JUL': '07',
    'AUG': '08',
    'SEP': '09',
    'OCT': '10',
    'NOV': '11',
    'DEC': '12'
  };
  year = new Date().getFullYear();

  if (format == 'google') {

    day = parseInt(date.replace(/\D/g, ''));
    if (day < 10) {
      day = '0' + day;
    }

    date = date.toUpperCase();

    Object.keys(months).forEach(function (item, index) {
      if (date.search(item) >= 0) {
        month = months[item];
        return false;
      }
    });

    return '' + year + '' + month + '' + day;
  }
}

function convertTimeFormat(date) {

  hours = date.split('-');
  if (hours[0].search("am") >= 0) {

    start = hours[0].trim().replace('am', '');

    if (start.search(':') >= 0) {

      start.replace(':', '');
      if (start.length < 4) {
        start = '0' + start;
      }

      start = '' + start + '00';
    } else {

      if (start.length < 2) {
        start = '0' + start;
      }

      start = '' + start + '0000';
    }
  } else {

    start = hours[0].trim().replace('pm', '');

    if (start.search(':') >= 0) {

      start.replace(':', '');
    }

    start = parseInt(start) + 1200;
    start = '' + start + '00';
  }

  if (hours[1].search("am") >= 0) {

    end = hours[1].trim().replace('am', '');

    if (end.search(':') >= 0) {

      end.replace(':', '');

      if (end.length < 4) {
        end = '0' + end;
      }
    } else {
      if (end.length < 2) {
        end = '0' + end + '00';
      }

      end = '' + end + '0000';
    }
  } else {

    end = hours[1].trim().replace('pm', '');

    if (end.search(':') >= 0) {

      end.replace(':', '');
    }

    end = parseInt(end) * 100 + 1200;
    end = '' + end + '00';
  }

  return { 0: start, 1: end };
}

function convertTimezone(timezone, startDate) {

  switch (timezone) {
    case "Atlantic":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "ADT";
      } else {
        timeZone = "AST";
      }
      break;

    case "Alaska":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "AKDT";
      } else {
        timeZone = "AKST";
      }
      break;

    case "Central":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "CDT";
      } else {
        timeZone = "CST";
      }
      break;

    case "Eastern":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "EDT";
      } else {
        timeZone = "EST";
      }
      break;

    case "Hawaii":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "HADT";
      } else {
        timeZone = "HAST";
      }
      break;

    case "Mountain":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "MDT";
      } else {
        timeZone = "MST";
      }
      break;

    case "Newfoundland":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "NDT";
      } else {
        timeZone = "NST";
      }
      break;

    case "Pacific":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "PDT";
      } else {
        timeZone = "PST";
      }
      break;

    case "Pierre & Miquelon":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "PMDT";
      } else {
        timeZone = "PMST";
      }
      break;

    case "Western Greenland":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "WGST";
      } else {
        timeZone = "WGT";
      }
      break;

    default:
      timeZone = "";

  }

  return timeZone;
}

/*
 * Replace all SVG images with inline SVG
 */
function embbedSvgImages() {
  var parser = new DOMParser();

  qsa('img.svg').forEach(function (item, index) {
    //console.log('item',item);
    var img = item;
    var imgID = img.id;
    var imgClass = img.classList.item(0);
    var imgURL = img.getAttribute('src');

    var httpRequest = new XMLHttpRequest();
    httpRequest.onreadystatechange = function () {
      if (httpRequest.readyState === XMLHttpRequest.DONE && httpRequest.status === 200) {
        var data = httpRequest.responseText;
        var doc = parser.parseFromString(data, "image/svg+xml");

        var svg = doc.querySelector('svg');

        // Add replaced image's ID to the new SVG
        if (typeof imgID !== 'undefined') {
          svg.setAttribute('id', imgID);
        }
        // Add replaced image's classes to the new SVG
        if (typeof imgClass !== 'undefined') {
          svg.classList.add(imgClass);
          svg.classList.add('replaced-svg');
        }

        svg.removeAttribute('xmlns:a');

        img.parentNode.appendChild(svg);
        img.remove();
      }
    };
    httpRequest.open('GET', imgURL);
    httpRequest.send();
  });
}

/*
 * pure JS fade
 */

function _(el) {
  if (!(this instanceof _)) {
    return new _(el);
  }
  this.el = document.getElementById(el);
}

_.prototype.fade = function fade(type, ms) {
  var isIn = type === 'in',
      opacity = isIn ? 0 : 1,
      interval = 50,
      duration = ms,
      gap = interval / duration,
      self = this;

  if (isIn) {
    self.el.style.display = 'inline';
    self.el.style.opacity = opacity;
  }

  function func() {
    opacity = isIn ? opacity + gap : opacity - gap;
    self.el.style.opacity = opacity;

    if (opacity <= 0) self.el.style.display = 'none';
    if (opacity <= 0 || opacity >= 1) window.clearInterval(fading);
  }

  var fading = window.setInterval(func, interval);
};

/*
 * Pop Up
 */
function showPopUp(content, footerContent) {

  if (content !== '') {
    qs('#popup .box-content').innerHTML(content);
  }

  if (footerContent !== '') {
    qs('#popup .box-footer').innerHTML(footerContent);
  } else {
    qs('#popup .box-footer').remove();
  }

  qs('#popup').style.display = '';
  _('#popup').fade('out', 0);
  _('#popup').fade('in', 500);

  qs('#popup .close-button').addEventListener('click', function (e) {

    e.preventDefault();

    _('#popup').fade('out', 0);
  });
}

/**
 * Get the closest matching element up the DOM tree.
 * @private
 * @param  {Element} elem     Starting element
 * @param  {String}  selector Selector to match against
 * @return {Boolean|Element}  Returns null if not match found
 */
function getClosest(elem, selector) {

  // Element.matches() polyfill
  if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
      var matches = (this.document || this.ownerDocument).querySelectorAll(s),
          i = matches.length;
      while (--i >= 0 && matches.item(i) !== this) {}
      return i > -1;
    };
  }

  // Get closest match
  for (; elem && elem !== document; elem = elem.parentNode) {
    if (elem.matches(selector)) return elem;
  }

  return null;
}

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _amplitudeInitVanilla = __webpack_require__(2);

var _amplitudeInitVanilla2 = _interopRequireDefault(_amplitudeInitVanilla);

var _getPageNameFromLocation = __webpack_require__(6);

var _getPageNameFromLocation2 = _interopRequireDefault(_getPageNameFromLocation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init = exports.init = function init() {
  var pagename = (0, _getPageNameFromLocation2.default)(window.location.href);
  (0, _amplitudeInitVanilla2.default)(pagename);
  toggleActiveLink();
  addNavigationHandler();
  addCitySelectorHandler();
  addFormHandler();

  MktoForms2.loadForm("//app-ab10.marketo.com", "572-JSV-775", 1017);
  MktoForms2.loadForm("//app-ab10.marketo.com", "572-JSV-775", 1025);
};

document.addEventListener('DOMContentLoaded', init);

function toggleActiveLink() {
  var activeLink = void 0;
  var path = window.location.pathname;
  var navigation = document.querySelector('.user-groups .navigation');

  if (path.indexOf('faq') >= 0) {
    activeLink = navigation.querySelector('li:nth-child(3) a');
  } else if (path.indexOf('lead') >= 0) {
    activeLink = navigation.querySelector('li:nth-child(2) a');
  } else {
    activeLink = navigation.querySelector('li:nth-child(1) a');
  }

  activeLink.href = 'javascript:;';
  activeLink.classList.add('active');
  navigation.querySelector('button').innerHTML = activeLink.innerHTML;
}

function addNavigationHandler() {
  var navigation = document.querySelector('.user-groups .navigation');
  var button = navigation.querySelector('button');

  button.addEventListener('click', function (e) {
    navigation.classList.toggle('open');
  }, false);

  document.body.addEventListener('click', function (e) {
    if (!navigation.contains(e.target)) {
      navigation.classList.remove('open');
    }
  }, false);
}

function addCitySelectorHandler() {
  var city = document.querySelector('.city-selection');
  if (city) {
    var input = city.querySelector('input');
    var dropdown = city.querySelector('.dropdown');
    var field = dropdown.querySelector('.value');
    var options = dropdown.querySelectorAll('.menu span');

    dropdown.addEventListener('click', function (e) {
      dropdown.classList.toggle('open');
    }, false);

    options.forEach(function (option, i) {
      option.addEventListener('click', function (e) {
        field.innerHTML = e.target.innerHTML;
        field.classList.remove('placeholder');
        if (i === options.length - 1) {
          input.value = '';
          city.classList.add('entry');
        } else {
          input.value = e.target.innerHTML;
          city.classList.remove('entry');
        }
      }, false);
    });

    document.body.addEventListener('click', function (e) {
      if (!dropdown.contains(e.target)) {
        dropdown.classList.remove('open');
      }
    }, false);
  }
}

function addFormHandler() {
  var form = document.querySelector('form');

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (form.name === 'lead-request') {
      submitLeadForm();
    } else {
      submitJoinForm();
    }
    return false;
  });
}

// TODO: Look into removing Marketo library and using AJAX to call endpoint directly

function submitJoinForm() {
  var joinForm = MktoForms2.getForm(1017);
  var form = document.querySelector('.form');
  var email = document.forms['join-request'].email.value;
  var emailValid = /@.*?\./.test(email);

  if (emailValid) {
    joinForm.onSuccess(function (values, followUpUrl) {
      form.classList.add('confirmation');
      return false;
    });

    joinForm.setValues({
      FirstName: document.forms['join-request']['first-name'].value,
      LastName: document.forms['join-request']['last-name'].value,
      Email: email,
      pUGCity: document.forms['join-request'].city.value
    });

    joinForm.submit();
  } else {
    form.classList.add('email-error');
  }
}

function submitLeadForm() {
  var leadForm = MktoForms2.getForm(1025);
  var form = document.querySelector('.form');
  var email = document.forms['lead-request'].email.value;
  var emailValid = /@.*?\./.test(email);

  if (emailValid) {
    leadForm.onSuccess(function (values, followUpUrl) {
      var form = document.querySelector('.form');
      form.classList.add('confirmation');
      return false;
    });

    leadForm.setValues({
      FirstName: document.forms['lead-request']['first-name'].value,
      LastName: document.forms['lead-request']['last-name'].value,
      Email: email,
      pUGCity: document.forms['lead-request'].city.value,
      userGroupCapacity: document.forms['lead-request'].capacity.value
    });

    leadForm.submit();
  } else {
    form.classList.add('email-error');
  }
}

/***/ }),

/***/ 118:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(101);

__webpack_require__(118);

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _functionsVanilla = __webpack_require__(1);

var functions = _interopRequireWildcard(_functionsVanilla);

var _analyticsHandlers = __webpack_require__(3);

var _analyticsHandlers2 = _interopRequireDefault(_analyticsHandlers);

var _analytics = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/*
 * Throttling function for scrolling events
 */
function throttle(delay, callback) {
  var previousCall = new Date().getTime();
  return function () {
    var time = new Date().getTime();

    if (time - previousCall >= delay) {
      previousCall = time;
      callback.apply(null, arguments);
    }
  };
}

var trackEvent = function trackEvent(event, payload) {
  payload ? analytics.track(event, payload) : analytics.track(event);
};

var getDataHandlerAttr = function getDataHandlerAttr(node) {
  return node.getAttribute('data-analytics-handler');
};

var getEventData = function getEventData(handler, currentPage, node) {
  var eventData = _analyticsHandlers2.default[handler];

  if (!eventData) {
    console.warn('No analytics handler for: ' + handler);
    return false;
  }

  return _analyticsHandlers2.default[handler](currentPage, node);
};

var attachClickEvent = function attachClickEvent(node, eventName, payload) {
  node.addEventListener('click', function (e) {
    trackEvent(eventName, payload);
  });
};

var attachHoverEvent = function attachHoverEvent(node, eventName, payload) {
  node.addEventListener('mouseenter', function (e) {
    e.stopPropagation();
    trackEvent(eventName, payload);
  });
};

var attachHoverNoClickEvent = function attachHoverNoClickEvent(node, eventName, payload) {
  node.addEventListener('mouseenter', function (e) {
    var clicked = false;
    var called = false;

    node.addEventListener('mousedown', function () {
      clicked = true;
    });

    node.addEventListener('mouseout', function (e) {
      if (!clicked && !called) {
        trackEvent(eventName, payload);
        called = true;
      }

      node.removeEventListener('mousedown');
      node.removeEventListener('mouseout');
    });
  });
};

var checkEventOptions = function checkEventOptions(pageName, options) {
  var lang = _analytics.convertLanguage[pageName];
  if (!(options && options.ignoreView)) {
    if (lang) {
      trackEvent('splash.regional.view', { locale: lang });
    } else {
      trackEvent('splash.' + pageName + '.view');
    }
  }
  if (options && options.trackScrolling) {
    addScrollEvent(pageName);
  }
};

var addCampaignTracking = function addCampaignTracking() {
  var campaignUtils = {};

  /*
   * Turn query param string into a hash.
   */
  campaignUtils.deparam = function deparam(str) {
    var pairs, hash;
    // remove the '?'
    if (!str || !str.length) {
      return;
    }

    if (str[0] === '?') {
      str = str.slice(1);
    }
    str = decodeURIComponent(str);

    // this gives back something of the form: [[key1, val1], [key2, val2]]
    pairs = str.split("&").map(function (item) {
      return item.split("=");
    });

    hash = {};
    pairs.forEach(function (pair) {
      hash[pair[0]] = pair[1];
    });

    return hash;
  };

  campaignUtils.extractCampaignAttributionData = function extractCampaignAttributionData(queryParams) {
    var campaignFields, campaignData;
    campaignFields = ["utm_source", "utm_medium", "utm_term", "utm_content", "utm_campaign"];
    campaignData = {};

    queryParams && campaignFields.forEach(function (field) {
      if (queryParams[field]) {
        campaignData[field] = queryParams[field];
      }
    });

    return campaignData;
  };

  var query, campaignData;
  query = campaignUtils.deparam(window.location.search);
  campaignData = campaignUtils.extractCampaignAttributionData(query);
  if (campaignData && campaignData.utm_campaign) {
    analytics.track('campaign', campaignData);
  }
};

var addScrollEvent = function addScrollEvent(pageName) {
  var sections = [].slice.call(document.querySelectorAll('section'));

  window.onscroll = throttle(300, function () {
    sections.forEach(function (thisSection, index, sectionArray) {
      var eventProperties = {};

      if (window.pageYOffset >= thisSection.offsetTop) {
        eventProperties.page_element = thisSection.getAttribute('data-scroll-element');
        trackEvent('splash.' + pageName + '.scroll', eventProperties);
        sections.splice(index, 1);
      }
    });
  });
};

var getAnalyticsHandlers = function getAnalyticsHandlers(node) {
  return getDataHandlerAttr(node).split(',');
};

var attachAnalyticsToDOM = function attachAnalyticsToDOM(currentPage, options) {
  document.querySelectorAll('[data-analytics-handler]').forEach(function (node) {
    var handlers = getAnalyticsHandlers(node);

    handlers.forEach(function (handler) {
      var eventData = getEventData(handler, currentPage, node);

      if (!eventData) {
        return;
      }

      var eventType = eventData.eventType,
          eventName = eventData.eventName,
          payload = eventData.payload;


      if (eventType === 'click') {
        attachClickEvent(node, eventName, payload);
      }

      if (eventType === 'hover') {
        attachHoverEvent(node, eventName, payload);
      }

      if (eventType === 'hover-no-click') {
        attachHoverNoClickEvent(node, eventName, payload);
      }
    });
  });
};

var plangridTrackEvents = function plangridTrackEvents(pageName, options) {
  checkEventOptions(pageName, options);
  addCampaignTracking();
  attachAnalyticsToDOM(pageName);
};

exports.default = plangridTrackEvents;

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _getHeaderFooterClickEventName = __webpack_require__(4);

var _getHeaderFooterClickEventName2 = _interopRequireDefault(_getHeaderFooterClickEventName);

var _analytics = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  "header-logo-click": function headerLogoClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.header.plangrid.click',
      payload: {
        'current_page': (0, _analytics.getCurrentPage)(currentPage)
      }
    };
  },
  "header-link-click": function headerLinkClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: (0, _getHeaderFooterClickEventName2.default)(node, 'header'),
      payload: {
        'current_page': (0, _analytics.getCurrentPage)(currentPage)
      }
    };
  },
  "header-globe-click": function headerGlobeClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.regional.header.click',
      payload: {
        'locale': (0, _analytics.getRegionalHeaderLinkName)(node)
      }
    };
  },
  "regional-header-link-click": function regionalHeaderLinkClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.regional.header.click',
      payload: {
        'link': (0, _analytics.getRegionalHeaderLinkName)(node),
        'locale': (0, _analytics.getCurrentPage)(currentPage)
      }
    };
  },
  "regional-cta-click": function regionalCtaClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.regional.signup.submit',
      payload: {
        'locale': (0, _analytics.getCurrentPage)(currentPage)
      }
    };
  },
  "header-phone-click": function headerPhoneClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.header.phone.click',
      payload: {
        'current_page': currentPage
      }
    };
  },
  "header-login-click": function headerLoginClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.header.login.click',
      payload: {
        'current_page': (0, _analytics.getCurrentPage)(currentPage)
      }
    };
  },
  "header-signup-click": function headerSignupClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.header.signup.click',
      payload: {
        'current_page': (0, _analytics.getCurrentPage)(currentPage)
      }
    };
  },
  "header-mobile-expand-click": function headerMobileExpandClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.header.expand.click',
      payload: {
        'current_page': currentPage
      }
    };
  },
  "footer-link-click": function footerLinkClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: (0, _getHeaderFooterClickEventName2.default)(node, 'footer'),
      payload: {
        'current_page': currentPage
      }
    };
  },
  "footer-ios-download-click": function footerIosDownloadClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.home.download.click',
      payload: {
        'current_page': currentPage,
        'button_place': 'footer',
        platform: 'ios'
      }
    };
  },
  "footer-android-download-click": function footerAndroidDownloadClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.home.download.click',
      payload: {
        'current_page': currentPage,
        'button_place': 'footer',
        platform: 'android'
      }
    };
  },
  "footer-windows-download-click": function footerWindowsDownloadClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.home.download.click',
      payload: {
        'current_page': currentPage,
        'button_place': 'footer',
        platform: 'windows'
      }
    };
  },
  "home-product-explore-click": function homeProductExploreClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.home.product_explore.click'
    };
  },
  "home-video-click": function homeVideoClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.home.video.click'
    };
  },
  "home-video-hover-no-click": function homeVideoHoverNoClick(currentPage) {
    return {
      eventType: 'hover-no-click',
      eventName: 'splash.home.video.hover'
    };
  },
  "home-testimonials-click": function homeTestimonialsClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.home.testimonials.click'
    };
  },
  "home-mainCTA-ios-download-click": function homeMainCTAIosDownloadClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.home.download.click',
      payload: {
        'button_place': 'main_CTA',
        'platform': 'ios'
      }
    };
  },
  "home-mainCTA-windows-download-click": function homeMainCTAWindowsDownloadClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.home.download.click',
      payload: {
        'button_place': 'main_CTA',
        'platform': 'windows'
      }
    };
  },
  "home-mainCTA-android-download-click": function homeMainCTAAndroidDownloadClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.home.download.click',
      payload: {
        'button_place': 'main_CTA',
        'platform': 'android'
      }
    };
  },
  "home-secondaryCTA-signup-click": function homeSecondaryCTASignupClick() {
    return {
      eventType: 'click',
      eventName: 'splash.signup.submit',
      payload: {
        'button_place': 'secondary_CTA'
      }
    };
  },
  "home-mainCTA-signup-click": function homeMainCTASignupClick() {
    return {
      eventType: 'click',
      eventName: 'splash.signup.submit',
      payload: {
        'button_place': 'main_CTA'
      }
    };
  },
  "home-projects-category-click": function homeProjectsCategoryClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.home.projects_category.click',
      payload: {
        'context': (0, _analytics.transformNodeText)(node.text)
      }
    };
  },
  "home-projects-category-hover": function homeProjectsCategoryHover(currentPage, node) {
    return {
      eventType: 'hover',
      eventName: 'splash.home.projects_category.hover',
      payload: {
        'context': (0, _analytics.transformNodeText)(node.text)
      }
    };
  },
  "home-projects-explore-click": function homeProjectsExploreClick() {
    return {
      eventType: 'click',
      eventName: 'splash.home.projects_explore.click'
    };
  },
  "product-mainCTA-signup-click": function productMainCTASignupClick() {
    return {
      eventType: 'click',
      eventName: 'splash.product.signup.click',
      payload: {
        'button_place': 'main_cta'
      }
    };
  },
  "product-secondaryCTA-signup-click": function productSecondaryCTASignupClick() {
    return {
      eventType: 'click',
      eventName: 'splash.product.signup.click',
      payload: {
        'button_place': 'secondary_cta'
      }
    };
  },
  "product-bottomCTA-signup-click": function productBottomCTASignupClick() {
    return {
      eventType: 'click',
      eventName: 'splash.product.signup.click',
      payload: {
        'button_place': 'bottom_cta'
      }
    };
  },
  "product-ipad-arrow-click": function productIpadArrowClick() {
    return {
      eventType: 'click',
      eventName: 'splash.product.ipad_features.click'
    };
  },
  "product-feature-text-click": function productFeatureTextClick() {
    return {
      eventType: 'click',
      eventName: 'splash.product.text_features.click'
    };
  },
  "product-download-click": function productDownloadClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: (0, _analytics.downloadEventName)(currentPage),
      payload: (0, _analytics.getDownloadPayload)(node, currentPage)
    };
  },
  "feature-page-demo-click": function featurePageDemoClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.' + currentPage + '.demo.click'
    };
  },
  "feature-page-video-click": function featurePageVideoClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.' + currentPage + '.video.click'
    };
  },
  "feature-link-click": function featureLinkClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.' + currentPage + '.feature.click',
      payload: {
        'page-click': (0, _analytics.transformNodeText)(node.text)
      }
    };
  },
  "header-contact-click": function headerContactClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.' + currentPage + '.contact_sales.click'
    };
  },
  "sidenav-filter-click": function sidenavFilterClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.' + currentPage + '.filter.click',
      payload: {
        type: (0, _analytics.transformNodeText)(node.getAttribute('data-link-category'))
      }
    };
  },
  "sidenav-mobile-click": function sidenavMobileClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.' + currentPage + '.dropdown.click'
    };
  },
  "partner-sidenav-become-a-partner-click": function partnerSidenavBecomeAPartnerClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.resources.partners.contact.click',
      payload: {
        context: 'sidenav'
      }
    };
  },
  "partner-sidenav-explore-our-api-click": function partnerSidenavExploreOurApiClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.resources.partners.doc.click',
      payload: {
        context: 'sidenav'
      }
    };
  },
  "projects-project-click": function projectsProjectClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.projects.project.click',
      payload: {
        company_name: (0, _analytics.getCompanyFromNode)(node),
        project_name: (0, _analytics.getHref)(node)
      }
    };
  },
  "case-study-quote-click": function caseStudyQuoteClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.projects.quote.click',
      payload: {
        project_name: currentPage
      }
    };
  },
  "case-study-download-click": function caseStudyDownloadClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.projects.download.click',
      payload: {
        project_name: currentPage
      }
    };
  },
  "case-study-signup-click": function caseStudySignupClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.projects.signup.click',
      payload: {
        project_name: currentPage
      }
    };
  },
  "video-feature-click": function videoFeatureClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: (0, _analytics.featureExploreEventName)(currentPage),
      payload: (0, _analytics.getVideoPayload)(node, currentPage)
    };
  },
  "events-filter-click": function eventsFilterClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.events.filter.click',
      payload: {
        'filter': (0, _analytics.transformNodeText)(node.getAttribute('value'))
      }
    };
  },
  "userGroups-lead-click": function userGroupsLeadClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.user_groups.lead.click'
    };
  },
  "userGroups-join-click": function userGroupsJoinClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.user_groups.join.click'
    };
  },
  "userGroups-faq-click": function userGroupsFaqClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.user_groups.faq.click'
    };
  }
};

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(0),
    transformNodeText = _require.transformNodeText;

module.exports = function (node, option) {
  if (!(option === 'header' || option === 'footer')) {
    throw "Invalid option";
  }
  return 'splash.' + option + '.' + transformNodeText(node.text) + '.click';
};

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (href) {
  var splitHref = href.split('/');

  return splitHref[splitHref.length - 2].replace(/\-/g, '_');
};

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// /assets/js/userGroups.ad96a232a30ee5c39ffc.js